import React from 'react';

const Footer = () => (
  <footer className="bg-gray-900 text-white">
    <div className="container mx-auto py-16 px-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {/* Sobre nós */}
        <div className="lg:col-span-2">
          <h2 id="about" className="text-2xl font-bold mb-6 bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent">
            Sobre a Oxton
          </h2>
          <p className="text-gray-300 leading-relaxed mb-6">
            A Oxton não é somente uma fábrica de software, somos o parceiro que ajudará sua empresa a crescer com as ferramentas mais modernas do mercado.
            Contamos com uma equipe de desenvolvedores e gestores altamente qualificada
            para atender nossos clientes com excelência.
          </p>
          <div className="flex space-x-4">
            <a href="mailto:contato@oxton.com.br" className="text-gray-300 hover:text-indigo-400 transition-colors duration-300">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-indigo-400 transition-colors duration-300">
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
            <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-indigo-400 transition-colors duration-300">
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Serviços */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Nossos Serviços</h3>
          <ul className="space-y-2 text-gray-300">
            <li>
              <a href="#features" className="hover:text-indigo-400 transition-colors duration-300">
                Desenvolvimento Web
              </a>
            </li>
            <li>
              <a href="#features" className="hover:text-indigo-400 transition-colors duration-300">
                Aplicações Mobile
              </a>
            </li>
            <li>
              <a href="#features" className="hover:text-indigo-400 transition-colors duration-300">
                UX/UI Design
              </a>
            </li>
            <li>
              <a href="#features" className="hover:text-indigo-400 transition-colors duration-300">
                Consultoria Técnica
              </a>
            </li>
            <li>
              <a href="#features" className="hover:text-indigo-400 transition-colors duration-300">
                Manutenção e Suporte
              </a>
            </li>
          </ul>
        </div>

        {/* Contato */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Contato</h3>
          <div className="space-y-3 text-gray-300">
            <div className="flex items-center">
              <svg className="w-5 h-5 mr-3 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span>Rio de Janeiro, RJ</span>
            </div>
            <div className="flex items-center">
              <svg className="w-5 h-5 mr-3 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <a href="mailto:contato@oxton.com.br" className="hover:text-indigo-400 transition-colors duration-300">
                contato@oxton.com.br
              </a>
            </div>
            
          </div>
        </div>
      </div>
      
      {/* Copyright */}
      <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-100">
        <p>&copy; 2025 Oxton Soluções em T.I.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
